import BaseFilter from "./BaseFilter";

export default abstract class OptionFilter extends BaseFilter {
	protected shouldShowWithData(optionSelectorID: string, dataAttribute: string | undefined): boolean {
		let current_selection = document.getElementById(optionSelectorID);

		if (current_selection == null) {
			console.error("Movie countries filter can't be selected.");

			return true;
		}

		let current_selection_value = (<HTMLInputElement>current_selection).value;

		if (current_selection_value === "all") {
			return true;
		}

		if (dataAttribute == null) {
			console.error("Directors data attribute can't be selected.");

			return true;
		}

		return dataAttribute.split(",").includes(current_selection_value);
	}

	abstract shouldShow(gridItem: HTMLElement): boolean;
}
